module.exports = __webpack_public_path__ + "img/Abrollbehälter_Container.6e0d7310.svg";